import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LoginPage } from './LoginPage';

const mount = document.getElementById('spider-login-root');
if (mount) createRoot(mount).render(<StrictMode><LoginPage /></StrictMode>);
